import React from "react";
import {
  FeaturedCardContent,
  FeaturesContainer,
  FeaturesCard,
  FeaturedIcons,
} from "./index.styled";
import { CardContainer, TextContainer } from "../../pages/landing/index.styled";
import folderAdd from "../../assets/icons/folder-add.png";
import userTick from "../../assets/icons/user-tick.png";
import volumeHigh from "../../assets/icons/volume-high.png";
import noteIcon from "../../assets/icons/note.png";
import timerIcon from "../../assets/icons/timer-start.png";
import folderCloudIcon from "../../assets/icons/folder-cloud.png";
import icBg from "../../assets/images/ic-bg.svg";

const Features = () => {
  const featuresItems = [
    {
      id: 1,
      title: "دایره واژگانی بیش از ‌ ۳۰۰ هزار کلمه",
      content:
        "خدمتی جدید و متفاوت برای تعامل کاربران فارسی‌زبان.",
      icon: folderCloudIcon,
    },
    {
      id: 2,
      title: " خوانش و پردازش بلادرنگ",
      content:
        " بدون صرف زمان طولانی برای پردازش متن",
      icon: timerIcon,
    },
    {
      id: 3,
      title: "بیان درستِ جملات و کلمات",
      content:
        " بر اساس فارسی معیار و به دور از هرنوع لهجه‌ و گویش",
      icon: noteIcon,
    },
    {
      id: 4,
      title: "خوانش متن‌های رسمی و غیررسمی",
      content:
        "بسته به نیاز سازمان‌ها و نوع متن‌های مورد استفاده",
      icon: volumeHigh,
    },
    {
      id: 5,
      title: "خوانش با لحن طبیعی انسان",
      content:
        "خواندن غیرمکانیکی و غیرربات‌گونه متون با لحنی کاملاً طبیعی ",
      icon: userTick,
    },
    {
      id: 6,
      title: "یادگیری واژگان جدید",
      content:
        " در کمترین‌ زمان و بسته به کاربری این سرویس در سازمان‌ها",
      icon: folderAdd,
    },
  ];
  return (
    <FeaturesContainer className="container" id="features">
      <h2>ویژگی‌های آواشو</h2>
      <CardContainer>
        {featuresItems.map((item) => (
          <FeaturesCard key={item.id}>
            <FeaturedIcons>
              <div>
                <img src={icBg} alt="ic-bg" />
              </div>
              <div>
                <img src={item.icon} alt="icon" />
              </div>
            </FeaturedIcons>
            <FeaturedCardContent>
              <div>
                <h3>{item.title}</h3>
              </div>
              <TextContainer width="100%">
                <p>{item.content}</p>
              </TextContainer>
            </FeaturedCardContent>
          </FeaturesCard>
        ))}
      </CardContainer>
    </FeaturesContainer>
  );
};

export default Features;
